import type { FC } from 'react'
import React from 'react'
import { Checkboard as CheckboardComponent } from 'react-color/lib/components/common'
import type { CheckboardProps } from './types'

export const Checkboard: FC<CheckboardProps> = ({
  size = 6,
  white = 'var(--bg-primary)',
  grey = 'var(--border-secondary)',
}) => {
  return <CheckboardComponent size={size} white={white} grey={grey} />
}
